import axios from "axios";
import React, { useState, useEffect, useContext, useMemo } from "react";
import { useParams } from "react-router-dom";
import OfficerCard from "../../common/officerCard";
import "./index.scss";
import Breadcrumbs from "../../common/breadcumb";
import Loading from "../../common/loading";
import Errors from "../../common/error";
import { TabTitle } from "../../common/dynamicTitle";
import { LangContext } from "../../context/LangContext";
function Officers() {
  const lang = useContext(LangContext);
  const nep = lang.state.np;
  let { slug } = useParams(null);
  TabTitle(`GMBF | ${slug}`);
  const [officers, setOfficers] = React.useState();
  const APIURL = `${process.env.REACT_APP_URL}Officer/holder/`;
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(false);

  switch (slug) {
    case "grievance-handling-officer":
      slug = "Grievance";
      break;
    case "compliance-officer":
      slug = "Compliance";
      break;
    case "information-officer":
      slug = "Information";
      break;
    default:
  }
  React.useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        setError(false);
        const response = await axios.get(`${APIURL}${slug}`);
        setOfficers(response.data.officer);

        setLoading(false);
      } catch (error) {
        setError(true);
        setLoading(false);
      }
    })();
  }, [slug]);
  const pageTitle = useMemo(() => {
    switch (slug) {
      case "Grievance":
        return nep ? "गुनासो व्यवस्थापन अधिकारी" : "Grievance Handling Officer";
      case "Compliance":
        return nep ? "अनुपालना अधिकृत" : "Compliance Officer";
      case "Information":
        return nep ? "सूचना अधिकारी" : "Information Officer";
      case "company-secretary":
        return nep ? "कम्पनी सचिव" : "Company Secretary";
      default:
        return slug;
    }
  }, [slug, nep]);
  if (loading) return <Loading />;
  if (error) return <Errors />;
  return (
    <>
      <Breadcrumbs PageTitle={pageTitle} />
      <main className="InsidePageContainer">
        <div className="main-box">
          <div className="wrapper">
            <div className="main-box-container">
              {officers.map((officer) => {
                return (
                  <div className="officer-body">
                    <OfficerCard key={officer.id} officer={officer} nep={nep} />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

export default Officers;
